import { Color, Icon, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Pressable, PressableProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import { GeoResult } from 'zens-store'

const COLOR_VERY_LIGHT_GREY_BLUE = '#EDF7FF'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    paddingHorizontal: Spacing.S,
    paddingVertical: Spacing.XS,
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: Color.calmGrey,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: Spacing.XS,
  },
  text: {},
  hovered: {
    backgroundColor: COLOR_VERY_LIGHT_GREY_BLUE,
  },
  pressed: {
    backgroundColor: Color.lightGreyBlue,
  },
})

interface Props extends Omit<PressableProps, 'style'> {
  result: GeoResult
  style?: StyleProp<ViewStyle>
}
const Result = (props: Props) => {
  const { result, style, ...otherProps } = props

  const renderContent = (state: { pressed: boolean; hovered?: boolean }) => {
    const { title, description } = result
    const { pressed, hovered } = state

    return (
      <View style={[styles.content, hovered && styles.hovered, pressed && styles.pressed]}>
        <View style={styles.icon}>
          <Icon name="building" size={18} />
        </View>
        <View style={styles.text}>
          <Text>{title}</Text>
          <Text>{description}</Text>
        </View>
      </View>
    )
  }
  return (
    <Pressable style={[styles.container, style]} {...otherProps}>
      {renderContent}
    </Pressable>
  )
}

export default Result
